export const publicFetch = async (url, options = {}) => {

    const publicSiteData = useState('publicSiteData', () => null);

    if (!publicSiteData.value?.id) {
        throw new Error('Public site data not available. Make sure public-site middleware has run.');
    }

    const requestOptions = {
        ...options,
        headers: {
            'Accept': 'application/json',
            ...options.headers,
            SiteId: publicSiteData.value.id
        }
    };
    
    // Only set Content-Type if not already set and not FormData
    if (!options.headers?.['Content-Type'] && !(options.body instanceof FormData)) {
        requestOptions.headers['Content-Type'] = 'application/json';
    }
    
    // Use $fetch for the request (no authentication headers)
    const config = useRuntimeConfig();
    url = config.public.apiUrl + url;
    return $fetch(url, requestOptions);
};